module.exports = __webpack_public_path__ + "img/violet_115.deef4552.png";